const enLang = {
    active: 'Active',
    actual: 'Actual',
    actual_return: 'Actual Return',
    actual_total: 'Actual Total',
    add_payment: 'Add Payment',
    advance: 'Advance',
    all: 'All',
    cancelled: 'Cancelled',
    current: 'Current',
    customer_information: 'Customer Information',
    generate_customer_link: 'Generate Customer Link',
    customer_link_generated: 'Customer link generated',
    service_rating: 'Service Rating',
    rating_saved: 'Rating saved',
    rating_report: 'Rating Report',
    rating_questions: 'Rating Questions',
    maintenance_ratings: 'Maintenance Ratings',
    admin_only_questions: 'Only admin users can save rating questions.',
    rating_secure_link_required: 'Rating requires the secure customer link.',
    timeline: 'Timeline',
    pending_approval: 'Pending Approval',
    requested_items: 'Requested Items',
    due_today: 'Due today',
    on_track: 'On track',
    no_due_date: 'No due date',
    average: 'Average',
    question_ar: 'Arabic Question',
    question_en: 'English Question',
    required: 'Required',
    sort: 'Sort',
    yes_no: 'Yes / No',
    rating: 'Rating',
    damage_payment: 'Damage Payment',
    deduction: 'Deduction',
    device: 'Device',
    device_rental: 'Device Rental',
    devices: 'Devices',
    financials: 'Financials',
    general: 'General',
    hour: 'Hour',
    inspection: 'Inspection',
    insurance_amount: 'Insurance Amount',
    insurance_return: 'Insurance Return',
    invoiced: 'Invoiced',
    issue: 'Issue',
    issue_total: 'Issue Total',
    items: 'Items',
    manual_device: 'Manual Device',
    month: 'Month',
    no_data: 'No data',
    number: '#',
    overdue: 'Overdue',
    payment: 'Payment',
    period: 'Period',
    planned: 'Planned',
    planned_total: 'Planned Total',
    quantity: 'Quantity',
    remaining: 'Remaining',
    rental_payment: 'Rental Payment',
    start: 'Start',
    start_rent: 'Start Rent',
    subtotal: 'Subtotal',
    unit_price: 'Unit Price',
    units: 'Units',
    week: 'Week',
    langname: 'en',
    dir: 'ltr',
    ldir: 'rtl',
    algin: 'left',
    lalgin: 'right',
    invoiceno: 'Invoice No.',
    plate_number: 'Plate No.',
    main_menu: 'Main Menu',
    search: 'Search',
    invoices: 'Invoices',
    add_invoice: 'Add invoice',
    invtype: 'Invoice Type',
    customer: 'Customer',
    mobile: 'Mobile',
    plate: 'Plate',
    model: 'Model',
    inv_date: 'Date',
    total: 'Total',
    vat: 'VAT',
    ftotal: 'Total inc. VAT',
    paid: 'Paid',
    remain: 'Remain',
    remain_amount: 'Remianing Amount',
    action: 'Action',
    status: 'Status',
    view: 'View',
    totals: 'Totals',
    close: 'Close',
    open: 'Open',
    customer_name: 'Customer Name',
    customer_type: 'Customer Type',
    general_maintenance_request: 'General Maintenance Request',
    add_general_maintenance_request: 'Add Device Request',
    device_checkup: 'Device Checkup',
    add_device_check: 'Receive Device',
    device_info: 'Device Information',
    device_name: 'Device Name',
    device_model: 'Device Model',
    serial_number: 'Serial Number',
    device_accessories: 'Accessories',
    device_received_status: 'Received Status',
    device_name_required: 'Device name is required',
    please_add_one_device_received_status: 'At least one device received status must be added',
    please_add_one_device_maintenance: 'At least one maintenance request must be added',
    add_edit: 'Add/Edit',
    select_action: 'Select action',
    allowed_file_types: 'PDF - Docx - xlsx - jpg - png',
    megabyte_abbr: 'MB',
    company_name: 'Company name',
    comapny_address: 'Company address',
    company_vatid: 'VAT Number',
    car_model: 'Model',
    car_year: 'Year made',
    car_color: 'Color',
    invoice_type: 'Invoice type',
    vat_type: 'VAT type',
    payment_method: 'Payment method',
    saler_name: 'Saler name',
    invoice_date: 'Invoice date',
    invoice_details: 'Invoice details',
    item_code: 'Item code',
    description: 'Description',
    qtty: 'QTTY',
    item_price: 'Item price',
    discount: 'Discount',
    create_invoice: 'Create Invoice',
    cash_payment: 'Cash method',
    span_payment: 'Span method',
    add: 'Add',
    individual_client: 'Individual  ',
    company_clinet: 'Comp. client',
    prices_include_vat: 'Prices include vat',
    prices_exclusive_vat: 'Prices exclusive of vat',
    prices_without_vat: 'Without VAT',
    none_paid_invoice: 'None Paid Invoice',
    paid_invoice: 'Paid Invoice',
    bank_payment: 'Bank Transfer',
    multi_payments: 'Multi payment method',
    required_field: 'This field is required',
    you_can_not_add_empty_invoice: 'Can not add empty invoice',
    company_ifnormation_required: 'Company information required - Name, Address, CR Numebr',
    invoice_added: 'Invoce Added',
    can_not_add_item_withoud_discription: 'Can not add item without description',
    item_qtty_must_be_more_than_zero: 'Can not add item with zero QTY',
    item_price_must_be_more_than_zero: 'Can not add item with zero price',
    print_invoice: 'Print Invoice',
    view_pdf: 'View PDF',
    invoice_return: 'Return Invoice',
    make_payment: 'Make a payment',
    invoice_tme: 'Invoice Time',
    return_date: 'Return Date',
    return_time: 'Return time',
    return_case: 'Return resone',
    total_exclusive_vat: 'Total exclusive vat',
    total_include_vat: 'Total include VAT',
    payments: 'Payments',
    payment_date: 'Payment date',
    payment_time: 'Payment time',
    payment_amount: 'Payment amount',
    payment_cash: 'Payment cash',
    payment_span: 'Payment Span',
    payment_bank: 'Payment Bank',
    return_invoice: 'Return Invoice',
    return_amount: 'Return amount',
    return: 'Return',
    system_modules: 'Modules',
    customers: 'Customers',
    quotations: 'Quotations',
    accounting: 'Accounting',
    envintory: 'Envintory',
    reports: 'Reports',
    settings: 'Settings',
    logout: 'Logout',
    invoice_notes: 'Invoice Notes',
    add_customer: 'Add Customer',
    additional_mobile: 'Additional Number',
    client_statement: 'Statements',
    mobil_10_digits: 'Mobile No. Must be 10 digits',
    customer_added: 'Customer Added sucsessfuly',
    add_quotation: 'Add Quotation',
    quotnumber: 'Quot No.',
    salesman: 'Salesman',
    salesman_report: 'Salesman Report',
    issued_by: 'Issued By',
    group_by: 'Group By',
    invoices_count: 'Invoices',
    returns_count: 'Returns',
    returns_total: 'Returns Amount',
    net_total: 'Net Sales',
    select_user_for_details: 'Click a row to see its invoices',
    quot_date: 'Quotation date',
    quotation_details: 'Quot Details',
    delete: 'Delete',
    company_client: 'Company Client',
    can_not_add_empty_row: 'Can not add empty row',
    please_add_company_info: 'Please add company information',
    quotation_added: 'Quotatin added',
    can_not_add_row_without_discription: 'Can not add row without discription',
    can_not_add_row_with_qtty: 'Please add qtty more than 0',
    date: 'Date',
    credit: 'Credit',
    debit: 'Depit',
    new_quotations: 'New quotations',
    invoiced_quots: 'Invoiced Quots',
    canceled_quots: 'Canceled Quots',
    quotation_no: 'Quot No.',
    printQuot: 'Print Quot.',
    cancel_quto: 'Cancel Quot.',
    quot_time: 'Quot Time',
    print: 'Print',
    cash_total: 'Cash Total',
    span_total: 'SPAN total',
    voutcher_no: 'Voutcher No.',
    receive_from: 'Receive From',
    receive_by: 'Receive By',
    cash: 'Cash',
    span: 'SPAN',
    received_voucher: 'Catch Receipt',
    exchange_voucher: 'Exch. voucher',
    employees: 'Employees',
    recurring_expensess: 'Recurring Expensess',
    add_voutchre: 'Add Voutcher',
    voutcher_resone: 'Voutcher Resone',
    emp_name: 'Employee name',
    id_number: 'ID number',
    basic_salary: 'Basic Salary',
    home_allownance: 'Home Allownance',
    trans_allownance: 'Transport Allownance',
    food_allown: 'Food Allownance',
    other_allown: 'Other Allownance',
    goze_perc: 'GOZE',
    percentate: 'Percentage',
    update: 'Update',
    add_employee: 'Add employee',
    add_expenses: 'Add Expenses',
    expense_type: 'Expense Type',
    yearly: 'Yearly',
    midterm: 'Midterm',
    quarterly: 'Quarterly',
    monthly: 'Monthly',
    daily: 'Daily',
    expense_total: 'Expense Total',
    expense_period: 'Expense Period',
    calculation_will_be_done_automatic: 'Calculation values will be done automaticlly',
    office_rent: 'Office Rent',
    add_maint_request: 'Add Job Order',
    cardid: 'Card No.',
    received: 'Received',
    delivered: 'Delivered',
    spare_partes: 'Spare Parts',
    spare_parts: 'Spare Parts',
    request_spare_parts: 'Request Spare Parts',
    request_spare_parts_items: 'Request Spare Parts Items',
    spare_parts_requests: 'Spare Parts Requests',
    purchase_requests: 'Purchase Requests',
    done: 'Done',
    not_done: 'Not Done',
    decline: 'Decline',
    confirm_decline_spare_request: 'Are you sure you want to decline this spare parts request?',
    confirm_approve_spare_request: 'Are you sure you want to approve this spare parts request?',
    deliver_spare_part: 'Deliver Part',
    confirm_deliver_spare_part: 'Confirm that this spare part was delivered to the technician?',
    waiting_technician_receipt: 'Waiting for technician receipt',
    confirm_create_purchase_bill: 'Are you sure you want to create purchase bill / mark this request as ordered?',
    main_info: 'Main info',
    received_date: 'Received date',
    delivery_date: 'Delivery date',
    customer_info: 'Customer Info',
    company_info: 'Company Info',
    car_info: 'Car Info',
    received_status: 'Received Status',
    work_description: 'Work Description',
    worker: "Worker",
    work_price: 'Work Price',
    advanced_payment: 'Advanced payment',
    attachement: 'Attatchment',
    choose_file: 'Choose File',
    save: 'Save',
    additional_information: 'Additional Information',
    work_description_required: 'Work Description Required',
    added_sucess: 'Added Success',
    add_user: 'Add user',
    update_user: 'update user',
    users: 'Users',
    user_name: 'Full name',
    login_name: 'Username',
    permission: 'Permissions',
    last_login: 'Last Login',
    save_login_info: 'Save Login Info',
    password: 'Password',
    export_excel: 'Export excel',
    add_purcahse: 'Add purcahse',
    vendor: 'Vendor',
    vendors: 'Vendors',
    purchase: 'Purchase',
    purchase_order: 'Purchase Order',
    purchase_return: 'Purchase Return',
    purchase_report: 'Purchase Report',
    inventory: 'Inventory',
    item_name: 'Item name',
    sales_invoices: 'Sales Invocies',
    sales: 'Sales',
    vat_required_return: 'VAT Required (Return)',
    vat_report: 'VAT Report',
    dealy_report: 'Dealy report',
    card_report: 'Card Report',
    sales_report: 'Sales Report',
    return_report: 'Return report',
    percentage: 'Percentage',
    income: 'Income',
    expenses: 'Expenses',
    expense: 'Expense',
    period_expenses: 'Period Expenses',
    closed_by: 'Closed By',
    return_by: 'Return By',
    shortcust_name: 'Shortcut name',
    vat_number: 'VAT Number',
    system_settings: 'System Settings',
    welcometo: 'Welcome',
    view_invoice  : 'View Invoice',
    added_date: 'Added Date',
    added_time: 'Added Time',
    photo_gallary: 'Photo Gallary',
    print_card: 'Print Card',
    car_description: 'Car description',
    invoice_samary: 'Invoice Summary',
    others: 'Others',
    view_card: 'View Card',
    card_closed: 'Card closed',
    please_check_data: 'Please check the data',
    cant_close_card_when_it_not_fully_paid: 'Please first make all remaining payment',
    card_saved: 'Card Saved',
    customerid: 'Customer ID',
    purchase_invoice: 'Purchase Bills',
    billno: 'Bill No',
    vendor_name: 'Vendor Name',
    vendor_mobile: 'Vendor Contact No.',
    vendor_vatids: 'Vendor VAT No.',
    vendor_address: 'Vendor Address',
    type: 'Type',
    bill_type: 'Bill Type',
    bill_detates: 'Bill Details',
    item_unit: 'Item Unit',
    pace: 'Pace',
    view_purchase_bill: 'View Purchase Bill',
    received_amount: 'Received Amount',
    close_card: 'Close Card',
    chose_file: 'Choose your file',
    upload: 'Upload',
    full_name: 'Full name',
    total_amount: 'Total Amount',
    buy_goods: 'Buy goods',
    sallary: 'Sallary',
    buy_devices: 'Buy devices',
    pay_for_bills: 'Pay bills',
    added_successfuly: 'Successfuly Added',
    nationality: 'Nationality',
    percent: 'Percent',
    group_name: 'Group name',
    permissions: 'Permissions',
    administratior: 'Administrator',
    full_permissions: 'Full permissions',
    accountant: 'Accountant',
    accountatn_permissions: 'Full permissions without setting',
    cashier: 'Cashier',
    cashier_permissions: 'Invoice system and generate cards',
    choose_employee: 'Choose employee',
    user_name_and_full_name_required: 'Login name and full name are required',
    user_password_required: 'Password is required for a new user',
    username_already_exists: 'This login name is already used',
    employee_already_linked: 'This employee is already linked to another user',
    employee_not_found: 'Employee not found',
    projectname: 'Project Name',
    inprogress: 'Progress',
    closed: 'Closed',
    not_invoiced: 'Un Billed',
    vendorid: 'Vendor ID',
    paid_in_advanced: 'Advanced Payment',
    paid_in_advanced_amount: 'Amount',
    installment_number: 'Installment #',
    installment_amount: 'Installment Amount',
    mor_than_zero: 'Please add number more than zero',
    emp_reward: 'Rewarded',
    reward_amount: 'Reward Amount',
    reward_resone: 'Reward resone',
    emp_deducts: 'Deducts',
    deducts_amount: 'Deduct Amount',
    deducts_resone: 'Deduct Resone',
    canceled: 'Canceled',
    notpaid: 'Not Paid',
    workstartdate: 'Work Start Date',
    fix_salary: 'Salary Issue',
    card_expenses: 'Maint. Expenses from inventory',
    invoice_expenses: 'Invoice Expenses',
    expenses_summary: 'Expenses Summary',
    general_expenses: 'General Expenses',
    cards_expenses: 'Maintenance',
    invoices_expenses: 'Invoices',
    salaries: 'Salaries',
    add_general_expense: 'Add Expense',
    periodically: 'Periodically',
    payit: 'Pay Now',
    pay_expenses: 'Pay Expenses',
    payment_period: 'Payment Period',
    expense_amount: 'Amount',
    othermethod: "Other methods.", 
    invoices_total: 'Invoice Totals', 
    invoices_remain: 'Invoice Remaining', 
    other_expenses: 'Other Exp.', 
    exp_total: 'Exp. total', 
    exp_vat:'Exp. VAT',
    employees_and_users: 'Employees',
    building_no: 'Building No.',
    street_name: 'Street Name',
    branch_number: 'Branch No.',
    district: 'District',
    zipcode: 'Zipcode',
    city:'City',
    address: 'Address',
    update_customer: 'Update Customer',
    customer_updated: 'Customer Updated',
    update_all: 'Update all',
    update_all_notes: 'Update All: Update all invoices or receipts with the new data',
    curency: 'SAR',
    pos: 'Point of Sale',
    cancel: 'Cancel',
    total_after_discount: 'Total After Discount',
    multi_payment: 'Multi Payment Methods',
    paid_amount: 'Paid Amount',
    category_name: 'Category',
    category_name_ar: 'Name Ar',
    category_name_en: 'Name En',
    category_type: 'Cat. Type',
    category_parent: 'Parent',
    subcat_count: 'Sub cats.',
    products: 'Items',
    add_category: 'Add Category',
    main_cat: 'Main Category',
    sub_cat: 'Sub Category',
    // -- product categories / barcode labels --
    show_in_pos: 'Show on POS',
    rows_per_page: 'Rows per page',
    total_rows: 'Total rows',
    no: 'No',
    type_to_search: 'Type to search...',
    searching: 'Searching...',
    no_results: 'No results',
    showing_first: 'Showing first',
    of: 'of',
    generate_code: 'Generate a new code',
    measure_unit: 'Unit',
    inches: 'Inches',
    millimetres: 'Millimetres',
    per_page: 'per page',
    barcode_width_share: 'Width of label',
    barcode_size_is: 'Barcode',
    barcode_too_fine: 'bars are too fine to scan reliably',
    barcode_wont_fit: 'the barcode is wider than the label',
    invalid_codes: 'item(s) whose code does not fit the chosen symbology',
    copy: 'Copy',
    copy_of: '(copy)',
    barcode: 'Barcode',
    print_barcodes: 'Print barcodes',
    barcode_print: 'Print barcodes',
    paper_and_margins: 'Paper & margins',
    paper_size: 'Paper size',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    page_width: 'Width',
    page_height: 'Height',
    margin_top: 'Top',
    margin_bottom: 'Bottom',
    margin_left: 'Left',
    margin_right: 'Right',
    label_grid: 'Label grid',
    columns: 'Columns',
    rows: 'Rows',
    gap_x: 'Gap X',
    gap_y: 'Gap Y',
    label_copies: 'Copies',
    font_size: 'Font size',
    cut_guides: 'Cut guides',
    barcode_settings: 'Barcode',
    show_barcode: 'Show barcode',
    barcode_type: 'Symbology',
    code_source: 'Encode field',
    barcode_width: 'Bar width',
    barcode_height: 'Bar height',
    show_code_text: 'Show code text',
    what_to_print: 'What to print',
    preview: 'Preview',
    updating: 'Updating...',
    no_preview: 'No preview',
    refresh_preview: 'Refresh preview',
    download_pdf: 'Download PDF',
    label_size: 'Label size',
    income_report: 'Income Report',
    incomes: 'Incomes',
    amountprice: 'Amount',
    itotals_per_paymethod: 'Income Totals per Payment Method',
    ototals_per_paymethod: 'Outcome Totals per Payment Method',
    account_statement: 'Account Statment',
    balance: 'balance',
    accounts: 'Accounts',
    account_balance_report: 'Balance Report',
    openingbalance: 'Opining Balance',
    transaction: 'Transaction Balance',
    account: 'Account',
    vlaue: 'Value',
    chart_of_account: 'Chart Of Account',
    definition: 'Definitions',
    paytypes: 'Payment Method',
    car_report: 'Car Report',
    amounttotal: 'Amount Total',
    namear: 'Arabic Name',
    nameen: 'English Name',
    classid: 'Account No.',
    add_pay_type:'Add payment Type',
    statment: 'Statement',
    class_name: 'Account name',
    fixed_assets: 'Fixed Assets',
    late: 'Late',
    price: 'Price',
    invoice_total: 'Invoices Total',
    vat_total: 'VAT Total',
    add_vendor: 'Add vendor',
    update_vendor: 'Update Vendor',
    vendor_updated_successufly: 'Vendor Added/Updated successfuly',
    vendor_name_required: 'Vendor Name Required',
    vendor_mobile_required: 'Vendor Mobile Required',
    finance_jvs: 'J-Voucher',
    jvnom: 'JV #',
    notes: 'Notes',
    addJV: 'Add JV',
    bnl_report: 'PNL Report',
    balance_report: 'Balance Report',
    gozi_report: 'GOZI Report',
    sales_crm: 'Sales',
    exp_management: 'Management Exp.',
    maintenance_cards: 'Maintenance Cards',
    customer_info_required: 'Customer name/mobile required',
    delivery_date_required: 'Delivery Date Required',
    car_info_required: 'Car info Required',
    please_choose_worker: 'Please choose worker',
    job_price_required: 'Job price required',
    customer_addedd: 'Custoemr Added',
    new: 'New',
    view_employee: 'View Employee',
    add_new_account: 'Add new account',
    account_name_ar: 'Arabic name',
    account_name_en: 'English name',
    mainaccount: 'Main Account',
    accoutn_option: 'Account Options',
    update_acount: 'Update Account',
    acount_name: 'Account name',
    account_type: 'Account Type',
    default_type: 'Default Type',
    account_integrated: 'Integrated with',
    integrated_with_expenses: 'Expenses Integrated',
    account_name: 'Account name',
    expeneses_type: 'Expenses type',
    projects: 'Projects',
    add_project: 'Add Project',
    additional_method: 'Additional Discound',
    adding_date: 'Adding Date',
    ammount: 'Amount',
    method: 'Method',
    home: 'Home',
    payment_requests:'Payments',
    requests:'Requests',
    ment_req_cards_new: 'Cards Maint. New',
    ment_req_cards_late: 'Cards Maint. Late',
    ment_req_cards_closed: 'Cards Maint. Closed',
    print_pagexport_pdfe: 'Export PDF',
    print_page: 'Print Page',
    sent_requests: 'Sents Requests',
    item_cost: 'Item Cost',
    username: 'Username',
    welcome: "Welcome",
    add_product: 'Add Product',
    orders: 'Orders',
    booktime: 'Book Time',
    engine_meter: 'Car meter reading (KM)',
    next_oil_change: 'Change oile after (KM)',
    crt_number: 'CR Number',
    national_address: 'National Address',
    vendor_party_type: 'Supplier Category',
    vat_15_digits_required: 'VAT number is required and must be 15 digits',
    crt_number_required: 'CR number is required for companies',
    building_no_4_digits: 'Building number is required and must be 4 digits',
    street_name_required: 'Street name is required',
    district_required: 'District is required',
    city_required: 'City is required',
    zipcode_5_digits: 'Postal code is required and must be 5 digits',
    additional_no_4_digits: 'Additional number is required and must be 4 digits',
    company_name_en: 'Company English Name',
    contact_number: 'Contact number',
    you_cannot_delete_this_item_paid_more_than_total: 'You cannot delete this item, total of this card is less than total paid',
    // vin_numebr: 'VIN Number',
    worker_name: 'Worker Name',
    start_date: 'Start date',
    end_date: 'End date',
    total_invoices: 'Total Invoices',
    total_remain: 'Total Remain',
    sendWhats: 'Send WhatsApp',
    salary_report: 'Salary report',
    percent_report: 'Percent report',
    cards_number: 'Cards Number',
    catd_totals: 'Cards Total',
    totalPercent: 'Total Percent',
    cards_expsenses: 'Cards Expenses',
    convert_to_invoice: 'Invoice Quot.',
    chose_month: 'Chose Month',
    year: 'Year',
    logo_img: 'Logo Image',
    terms_of_use: 'Terms of use',
    tafweed: 'Terms of use',
    expense_namear: 'Expenses Type Arabic Name',
    expense_nameen: 'Expenses Type English Name',
    expenses_type_updated: 'expenses type updated',
    add_new_expense_type: 'Add new expense type',
    expenses_type_added: 'expenses type added',
    income_expense_report: 'Income & Expense Report',
    other: 'other',
    expnese: 'Expenses',
    old_balance: 'Old Blance',
    purchase_bill: 'Purchase Bill',
    purchase_summary: 'Purchase summary',
    print_voucher: 'Print',
    sales_vat: 'Sales VAT',
    bill_vat: 'Purchase VAT',
    invoice_export: 'Create Invoice',
    add_expense_type: 'Add Expense Type',
    name_ar_en_required: 'Arabic/English type name required',
    add_direct_invoice: 'Add direct invoice',
    car_ifnormation_required: 'Car information required',
    save_n_print: 'Save And Print',
    print_in_voucher: 'Print',
    chose_customer_type: 'Chose Custoemr Type',
    chose_invoice_type: 'Chose Invoice Type',
    invoice_class: 'Invoice Classification',
    chose_invoice_class: 'Choose Invoice Classification',
    chose_vat_type: 'Chose VAT Type',
    chose_payment_method: 'Chose Payment Type',
    chose_saler_name: 'Chose Saler name',
    total_without_vat: 'Total Ex. VAT',
    fftotal: 'Total inc. VAT', 
    changePassword: 'Change Password',
    newpassword: 'New Password',
    oldpassword: 'Old Password',
    printing_header: 'Printing Header',
    invoice_body: 'Invoice Body',
    voucher_body: 'Voucher Body',
    card_body: 'Maint Card Body',
    printing_footer: 'Printing Footer',
    car_status_receive: 'Car receive status',
    add_attachement: 'Add Attachments',
    government_clinet: 'Government',
    view_page: 'Page Preview',
    return_invoices: 'Return Invocies',
    vat_summary: 'VAT Summary',
    // fftotal: 'Total Inc. VAT',
    add_edit_product: 'Add/Edit Product',
    current_qtty: 'Current Qtty',
    price_without_vat: 'Price Ex. VAT',
    price_inc_vat: 'Price Inc. VAT',
    default_cost: 'Default Cost',
    added_value_tax: 'Enable Added Value Tax',
    product_category: 'Product Category',
    product_type: 'Product Type',
    inventory_item: 'Inventory Item',
    service_item: 'Service Item',
    this_item_service_item: 'Only inventory item type can be add to purchase bill',
    day: 'Day',
    print_out_voucher: 'Print Voucher',
    expenses_type_reoprt: 'Expenses Type Report',
    view_quotation: 'View Quotation',
    view_expenses: 'View Expenses Invoice',
    customer_company_info_required: 'Company Name and address are required',
    for_more_information_or_support_firstline: 'For support, or any inquires please contat us',
    for_more_information_or_support_secondline: ' 0595907777 ',
    whatsapp: 'WhatsApp',
    add_invoice_notes: 'Add notes to Invoice (warranty - Terms, etc.)', 
    new_customer: 'New Customer',
    entity_name: 'Entity Name',
    branch_name: 'Branch Name',
    request_number: 'Requist Number',
    order_number: 'Order Number',
    po_number: 'Request Number',
    po_date: 'Request Date',
    add_car: 'Add new car',
    footer_extra: "Footer Extend",
    view_quot_pdf: 'Download ',
    bid_number: 'Bid Number',
    expenses_invoices: 'Expenses Invocie',
    chose_car: 'Chose a Car',
    total_b_d: 'Total Befor Discount',
    total_discount: 'Discount',
    cars_list: 'Cars List',
    out_payments: 'Out Voutcher',
    in_payments: 'In Voutcher',
    changeNote: 'Modify Note',
    are_you_sure: 'Are you sure?',
    add_invocie: 'Add invoice',
    add_new_card: 'Add Job Order',
    cars_status: 'Cars Status',
    reset: 'Reset',
    undo: 'Undo',
    chose_customer: 'Chose Customer',
    chose_company: 'Chose Company',
    chose_entity: 'Chose Entity',
    company_name_required: 'Company name required',
    customer_name_required: 'Customer name required',
    company_address_required: 'Company address required',
    entity_name_required: 'Entity name required',
    car_information_must_be_complated: 'Car information for car plate {{plate_number}} required',
    you_must_add_one_car_atleast: 'You must add one car at least',
    you_must_add_atleast_one_work_item: 'You must add one item to work job',
    plase_select_car_scratch: 'You can not add empty image',
    chose_car_before_continue: 'You must select car to continue',
    approve_card: 'Approve Card',
    isbilled: 'is Billed',
    complete: 'Complete',
    add_new_work_expenses: 'Add new work/Sparepart',
    row_type: 'Row Type',
    agree: 'Agree',
    details: 'Details',
    time: 'Time',
    payment_type: 'Payment Type',
    amount: 'Amount',
    debet: 'Debet',
    daily_summary_for_date: 'Daily Summary for date',
    today_balance: 'Day\' Balance',
    previews_balance: 'Previews Balance',
    total_balance: 'Total Balance',
    purchase_and_expenses:'Purchase & Expese',
    credit_note:'Credit Notes',
    period_balance: 'Period Balance',
    add_vendor_voucher: 'Exchange Vouch.',
    salary_paid: 'Salary Payment',
    client_statment: 'Client Statement',
    file_size: 'File size',
    file_name: 'File name',
    download: 'Download',
    cancel_order: 'Cancel Order',
    add_order: 'Add order',
    view_order: 'View order',
    orderid: 'Order ID',
    order_date: 'Order date',
    order_time: 'Order Time',
    order_details: 'Order Details',
    order_items: 'Order Items',
    cancel_qtty: 'Canceled Qtty',
    cancel_reson: 'Canceled Reson',
    full_cancel_reson: 'Full cancel resone',
    full_cancel: 'Full Cancel',
    partial_cancel: 'Partial cancel',
    custody: 'Custody',
    return_custody: 'Paid From Custody',
    remain_custody: 'Remain From Custody',
    add_custody: 'Add Custody',
    width: 'Width',
    thickness: 'Thickness',
    limited: 'Limited',
    customer_sign: 'Signature',
    back: 'Back',
    terms_and_conditions: 'Terms and conditions',
    work_hours: 'Working hours',
    vendor_payments: 'Vendor Payments',
    terms: 'Terms',
    pay_from_custdy: 'Pay from custdy',
    pay_from_cash: 'Pay from cash',
    emp_statment: 'Employee Statement',
    deduct_from_salary: 'Salary Deduct',
    pay_advanced: 'Pay Advanced',
    add_reward: 'Add rewared',
    post_salary: 'Post Salary',
    indemnity: 'Indemnity',
    posted_salary: 'Posted Salary',
    card_percentage:'Card Percentage',
    invoice_percentage: 'Invoice Percentage',
    remain_salary: 'Remain Salary',
    lated_salaries: 'Rest Salary',
    salary_total: 'Salary Total',
    custdy: 'Custdy',
    mentanace_card: 'Mentanance Cards',
    service: 'Services',
    deduct: 'deduct',
    paid_in_advanced_total: 'Paid Advanced Ttoal',
    number_of_parts: 'Number of Parts',
    part_amount: 'Part Amount',
    returned: 'Retrurend',
    deduct_resone: 'Deduct Resone',
    minute_late: 'Minute Late',
    deduct_type: 'Deduct type',
    monthly_late: 'Monthly late',
    deduct_amount: 'Deduct Amount',
    monthly_deduct: 'Deduct Monthly Amount',
    fix_it: 'Fix',
    today_date: 'Today Date',
    search_by_name: 'Search By Name',
    daily_report: 'Daily Report',
    max_items_sales: 'Most Sales',
    less_items_sates: 'Less Sales',
    zero_items: 'Zero Items',
    sales_qtty: 'Sales QTY',
    total_income: 'Total Income',
    current_qty: 'Current QTY',
    remainpso: 'Remain',
    open_shift: 'Sift Start',
    _total_1_ryals: '1 SAR',
    _total_5_ryals: '5 SAR',
    _total_10_ryals: '10 SAR',
    _total_20_ryals: '20 SAR',
    _total_50_ryals: '50 SAR',
    _total_100_ryals: '100 SAR',
    _total_500_ryals: '500 SAR',
    opening_balance: 'Opening Balance',
    open_new_shift: 'Open shift',
    calendar: 'Calendar',
    add_purchase: 'Add Purchase',
    clode_shift: 'Close Shift',
    total_payment_to_vendor: 'Remain vendor payments is: ',
    total_payment_to_Client: 'Remain Client payments is: ',
    client_statement_pos: 'Client Statement',
    client_appointment: 'Client Calendar',
    add_client_voucher: 'Add Client Payment',
    invoice_summary: 'Invoice Summary',
    total_after_discountt: 'Price After Discount',
    cashair: 'Cashair',
    managment: 'Management',
    smiller_products:'Smiller products',
    emp_custody: 'Custody',
    menu: 'Mentu',
    book_tables: 'Book Table',
    add_your_cash: 'Add your shift cash',
    mobile_info_required: 'Client mobile required and must more than 4 digits',
    mobile_info_required_fullmobile: 'Client mobile required and must start with 05 and more than 5 digits',
    name_info_required: 'Client name required and must more than 5 chars',
    view_customer: 'View Customer',
    add_fincance_request: 'Add F-Request',
    cars: 'Cars',
    add_notes: 'Add Notes',
    finance_report: 'Finance Report',
    unpaid_job_orders: 'Not Invoiced',
    report: 'Report',
    financial_request: 'Financial Requests',
    tasks: 'Tasks',
    add_task: 'Add Task',
    task_description: 'Task Description',
    dead_line: 'Dead Line',
    task_to: 'Task to User',
    task_description_required: 'Task description required',
    task_start_end_date_required: 'Task start & deadline required',
    start_time_required: 'Calendar start time & deadline time required',
    last_update_by: 'Updated By',
    last_update_date: 'Updated Date',
    closed_date: 'Closed Date',
    add_warantly: 'Warantly Job',
    plate_number_required: 'Plate number required',
    add_booking: 'Booking',
    start_time: 'Start time',
    deadline_time: 'Deadline time',
    book_calendar: 'Calendar',
    tasks_status: 'Tasks',
    warantly_status: 'Waratnly',
    calendar_status: 'Calendar',
    customer_status: 'Customer Stauts',
    ment_description: "Ment. Description",
    add_new_spare_part: 'Add Spare part',
    // item_name: 'Spare part name',
    spare_part_item_code: 'Spare part item code',
    add_spare_part: 'Add sparepart',
    work_type: 'Work Type',
    carsnumber: 'Cars Count',
    add_new_status: 'Add New Status',
    vin_numebr: 'VIN',
    brand_name: 'Car Make',
    ready_to_deliver: 'Ready',
    cancel_card: 'Cancel',
    vin_number: 'VIN',
    calendar_table: 'Calendar Table',
    choose_custoemr: 'Select Client',
    estimated_price: 'Estimated Price',
    work_name: 'Work Name',
    booking_procedure: 'Booking procedure',
    change_booking_date: 'Change booking',
    edit_calendar: 'Edit Calendar',
    expire_date: 'Expire date',
    note_date: 'Note date',
    added_by: 'Added by',
    task_type: 'task Type',
    training: 'Training',
    job_order: 'Job Order',
    last_update: 'Last update',
    last_action: 'Last Action',
    next_action: 'Next Action',
    next_action_date: 'Action Date',
    agent: 'Agent',
    view_crm: 'View CRM',
    generate_license: 'Gen. License',
    note_text: 'Note Text',
    note_type: 'Note Type',
    task_response: 'Response',
    license_url: 'License URL',
    copies: 'Number of License',
    include_computers: 'Include Computers',
    yes_19: 'Yes include 19 Inch',
    yes_24: 'Yes include 24 Inch',
    no_devices: 'No',
    last_action_date: 'Last Action Date',
    whats_type: 'Whats MSG type',
    whats_url_multi: 'Doc, Image, Vedio URL',
    update_task: 'Update Task',
    industrial: 'Industrial',
    support_ticket: 'Support',
    add_support: 'Add Support',
    send_date: 'Sent date',
    message_type: 'Message Type',
    message_text: 'Message Text',
    customer_number: 'Customers Number',
    sending_number: 'Sending Number',
    media_link: 'Media Link',
    send_whatsapp: 'Send WhatsApp',
    send_to: 'Sent To',
    sent_type: 'Sent Type',
    number_list: 'Numbers List',
    number_list_notes: 'Separate numbers with comma',
    image_url: 'Image URL',
    document_url: 'Document URL',
    vedio_url: 'Vedio URL',
    message_title: 'Subject',
    client_type: 'Client Type',
    cannot_delete_this_customer_invoices_found: 'This customer had Invoices you can not delete it',
    cannot_delete_this_customer_cards_found: 'This customer had JOB CARDS you can not delete it',
    custoemr_delete_done: 'Customer Deleted Successfuly',
    cannot_delete_this_vendor_invoices_found: 'This vendor had Invoices you can not delete it',
    cannot_delete_this_vendor_payment_found: 'This vendor had Payments you can not delete it',
    vendor_delete_done: 'Vendor Deleted Successfuly',
    employee_deleted: 'Employee Deleted',
    advanced_payment_deleted: 'Advanced Payment Deleted',
    employee_name: 'Employee Name',
    number_of_tasks: 'Tasks #',
    closed_tasks: 'Closed',
    canceled_tasks: 'Canceled',
    opened_tasks: 'Open',
    add_work_order: 'Add Work Order',
    owner_name: 'Car Owner Name',
    companies: 'Companies',
    exeute_date: 'Execute Date',
    task_priority: 'Task Priority',
    day_name: 'Day Name',
    industry: 'Industry',
    support: 'Support',
    project_type: 'Project Type',
    project_title: 'Project Title',
    project_owner: 'Project Owner',
    project_start: 'Project Start',
    project_deadline: 'Project Start',
    project_close_date: 'Project Closed',
    project_employees: 'Project Employees',
    employee: 'Employees',
    task: 'Task',
    task_title: 'Task Title',
    checklist: 'Check List',
    superVisor: 'Supervisor',
    super_visor_required: 'Supervisor required',
    mobile_required: 'Mobile required',
    new_sales: 'New Sales',
    return_sales: 'Return Sales',
    card_type: 'Card Type',
    add_store: 'Add Store',
    store_name_ar: 'Store Name AR',
    store_name_en: 'Store Name EN',
    account_number: 'Account Number',
    trans_from: 'Transfer From',
    trans_to: 'Transfer To',
    trans_type: 'Transfer Type',
    received_by: 'Received By',
    add_transfer: 'Add Transfer',
    add_sinventory: 'Add Inventory',
    // inventory_item: 'Add Inventory',
    start_qtty: 'Start QTTY',
    cost_price: 'Cost Price',
    add_contract: 'Add Contract',
    contract_id: 'Contract ID',
    last_maint_date: 'Last Maint Date',
    last_maint_by: 'Last Maint. By',
    cars_number: 'Cars Number',
    contract_date: 'Contract Date',
    contract_expire_date: 'Contract Expired On',
    contract_start_date: 'Contract Start Date',
    meter_car: 'Car Meter',
    supports: 'Supports',
    contracts: 'Contracts',
    job_cards: 'Job Card',
    expected_income: 'Expected Income',
    title: 'Title',
    old_invoice: 'Old Invoice',
    unitId: 'Unit Id',
    main_unit_ar: 'Arabic Main Unit name',
    main_unit_en: 'English Main Unit name',
    add_unit: 'Add Unit',
    update_units: 'Update Unit',
    unit_type: 'Unit Type',
    main_unit: 'Main Unit',
    vendor_code: 'Vendor Code',
    is_finalProduct: 'Item Type',
    saleable: 'Saleable',
    update_procedures: 'Update Procedures',
    procedure: 'Procedure',
    erocedure_date: 'Procedure Date',
    client_priority: 'Priority',
    web_url: 'Web URL',
    purchase_inv: 'Purchase Inv.',
    api_token: 'WhatApp API Token To get This code Please Call (0595907777)',
    send_attachment: 'Send Attachment',
    PublishMe: 'Generate License',
    client_source: 'Client Source',
    add_offer: 'Add Offer',
    offer_name: '',
    offer_start: '',
    offer_end: '',
    add_new: 'Add New',
    campaign_start: 'Campaign Start',
    campaign_start_time: 'Campaign Start Time',
    campaign_title: 'Campaign Title',
    what_to_send: 'What To Send',
    send: 'Send',
    working_time_star: 'Working Start',
    working_time_end: 'Working End',
    product: 'Product',
    last_10_messages: 'Last 10 Messages',
    executed_date: 'Executed Date',
    support_case: 'Support Case',
    support_procedure: 'Support Procedure',
    source: 'Source',
    service_name: 'Service Name',
    available_times: 'Available Times',
    support_type: 'Support Type',
    department: 'Department',
    customer_require: 'customer required',
    subject_require: 'subject required',
    start_date_require: 'start date required',
    executed_date_require: 'executed date required',
    deadline_require: 'deadline required',
    times_require: 'Please select 1 available time at least',
    notes_require: 'notes required',
    alert: "alert",
    error_no_qty: "This item not exist or there is no qtty, please add it throw purcahse invoice",
    mobile_alert_10: 'Mobile number must start with 05 and 10 digit',
    all_calr_plate_field_required: 'All Fields required',
    car_digit_4: 'Car plate digits 4 numbers',
    pay_more_than_price: 'Can not pay more than total of invoice',
    all_field_require: 'All fields required',
    date_out_of_day: 'You can not chose date more than today',
    date_required: 'Date required',
    empty_invoice_error: 'You can not add empty invoice',
    payment_method_error: 'Chose payment method',
    custoday_not_equal: 'Employee custoday not complete payment',
    call: 'Call',
    branches: 'Branches',
    taxes: 'taxes',
    stores: 'stores',
    successfuly_job: 'Job done',
    renewal_amount: 'Renewal Amount',
    renew: 'Renew',
    years: 'Years',
    temporary_expenses: 'Temp. Expenses',
    select_store_before_continue: 'Store Required',
    please_add_one_item_before_continue: 'Please add atleast 1 item to continue',
    company_name_and_company_address_required: 'Company name and address required',
    carstotal: 'Cars Total',
    item_totals: 'Items Total',
    created_by: 'Created By',
    card_supervisor: 'Card Tech',
    technical: 'Technical',
    brand: 'Brnad',
    color: 'Color',
    vin: 'VIN',
    visit_oursite: 'Visit our Site',
    from_store: 'From Store',
    to_store: 'To Store',
    available_qtty: 'Avaiable QTY',
    transfer_qtty: 'Transfer QTY',
    costs: 'Costs',
    wins: 'Total Profit',
    profit: 'Profit',
    unit_namear: 'Unint Arabic name',
    unit_nameen: 'Unint English name',
    no_account_en: 'No account',
    product_namear: "Product Arabic name",
    product_nameen: "Product English name",
    is_saleable: 'Is this product saleable',
    card_paid: "Paid",
    card_not_paid: "Not Paid",
    card_paid_status: 'Payment Status',
    note_text_required: 'Note text required',
    sub_accounts: 'Sub Accounts',
    add_sub_account: 'Add Sub Accounts',
    balance_type: 'Balanced',
    bnl_type: 'Profet & Lost',
    income_type: 'Income',
    other_type: 'Other',
    analyses_account:'Analyses',
    main_account: 'Main',
    gov_expenses: 'Government Expenses',
    update_journal:'Update Journal',
    add_new_journal: 'Add new Journal',
    error_date: 'Please chose date inside your Finance year',
    add_fixed_assets: 'Add Fixed Assets',
    udpate_fixed_assets: 'Update Fixed Assets',
    purchase_date: 'Purcahse Date',
    purchase_price: 'Purcahse Price',
    depreciation_rate: 'Depreciation Rate',
    depreciation_period: 'Depreciation Period',
    depreciation_amount: 'Depreciation Amount',
    current_price: 'Current Price',
    fixed_assets_namear: 'Fixes assets Arabic Name',
    fixed_assets_nameen: 'Fixed assets English Name',
    plase_add_assets_ar_name: 'Please add assets arabic name',
    plase_add_assets_en_name: 'Please add assets english name',
    please_add_purchase_price: 'Plase add Purchase Price',
    please_add_purchase_date: 'Plase add Purchase Date',
    please_add_qtty: 'Please add qtty',
    add_out_voucher: 'Add Voucher',
    edit_voucher: 'Update Voucher',
    delete_invoice: 'Delete Invoice',
    return_selected: 'Return Selected',
    delete_selected: 'Delete Selected',
    final_product: 'Final Product',
    raw_material: 'Raw Material',
    factory_item: 'Factory Item',
    salesable: 'Salesable',
    none_salesable: 'None Salesable',
    unit_name: 'Unit Name',
    sale_price: 'Sale Price',
    minimum_salse_price: 'Min Sale Price',
    maximum_salse_price: 'Max Sale Price',
    finger_print_id: 'Finger Print ID',
    employee_name_required: 'Employee name required',
    mobile_number_required: 'Mobile number require',
    base_salary_required: 'Base salary require',
    update_add_employee_success: "Update/Add employee successfuly",
    select_month: 'Select Month',
    select_year: 'Select year',
    custody_amount: 'Custoday Amount',
    attend_late: 'Attend Late',
    left_early: 'Left Early',
    not_attend: 'Not Attend',
    trial_in_balances: 'Trail in balances',
    trial_in_totals: 'Trial in totals',
    trial_balance : 'Trial Balance',
    hide_zero_accounts: 'Hide zero accounts',
    pnl_report: 'Profit and Lost Report',
    this_item_used_you_can_not_delete_it: 'This items used, you can not delte it',
    deleted_successfuly: 'Delteted Successfuly',
    parent_classid: 'Parent Class',
    parent_class_name: 'Parent Name',
    coa_report_with_totals: 'COA Report with Totals',
    coa_report: 'COA Report',
    inventory_report: 'Inventory Report',
    select_store: 'Select Store',
    add_periodic_maint: 'Add Periodc Maint',
    last_visit: 'Last Visit',
    visit_type: 'Visit Type',
    add_vacation: 'Add Vacation',
    number_of_days: 'Number of days',
    period_maint: 'Period Maint.',
    maint_prog: 'Maint. Programs',
    maint_contract: 'Maint. Contracts',
    updatePeriodMaint: 'Update Period',
    add_title: 'Ad Title',
    title_cond: 'Title',
    campaign_price: 'Campaign Price',
    return_quotation: 'Reactive',
    FixedAssets: 'Fixed Assets',
    all_regions: 'All Cities',
    exact_city: 'Exact City',
    campaign_area: 'Campaign Area',
    vehicle_type: 'Vehicle Type',
    campaign_end: 'campaign end',
    campaign_branches: 'Campaign Branches',
    campaign_target: 'Campaign Target',
    campaign_cost: 'Campaign Cost',
    campaign_clients: 'Campaign Clients',
    campaign_profit: 'Campaign Profit',
    created_date: 'Created Date',
    all_branches: 'All Branches',
    view_offer: 'View Offer',
    view_subscriber: 'View Subscriber',
    customer_afforded: 'Customer Afforded',
    car_digi_4: 'Car Plate Number must be 4 digits',
    afforded_customer_name: 'Afforded Client',
    sales_total: 'Sales Total',
    sales_ftotal: 'Sales Total With VAT',
    all_total: 'Requested Total',
    customer_support: 'Customer Support',
    calnder_all_field_required: 'Calender Fields are required',
    vacation_reasons: 'Vacation Reason',
    vacation_remains: 'Vacation Remain',
    vacation_start_date_required: 'Vacation start date required',
    vacation_reasons_required: 'Vacation reasons required',
    your_vacation_limit_is_overdue: 'Your Vacationd Days is over limit',
    vacations: 'vacations',
    refresh: 'refresh',
    chose_from_list: 'Chose',
    addes_successfuly: 'Added Successfuly',
    process_job_list: 'Procead Job Order',
    closed_job_list: "Closed Job Order",
    not_invoice_job_list: "Not Invoiced Job Order",
    invoiced_job_list: "Invoiced Job Order",
    current_paid_job_list: "Current Paid Job List",
    cashflow: "Cashflow",
    choose_mentainance_date: 'Choose Maintenance Date',
    maintenance_time: 'Maintenance Time',
    offers_programs: 'Offer Programs',
    program_name: 'Program name',
    booking_date: 'Booking Date',
    booking_time: 'Booking Time',
    contract_details: 'Contract Details',
    work_order: 'Work Order',
    print_job_order: 'Print job order',
    work_total_price: 'Work total',
    other_profit_total :'Other profit total',
    all_: 'All ',
    chose_store: 'Chose Warehouse',
    cost_center_name_ar: 'Cost Center Arabic',
    cost_center_name_en: 'Cost Center English',
    costCenter: 'Cost Center',
    addCostCenter: 'Add Cost Center',
    without_cost_center: 'Without Cost Center',
    account_client_type: 'Client Account Type',
    main_clients: 'Main Account',
    without_account: 'Customer Account',
    depreciation_account: 'Depreciation Account',
    quarter: 'Quarter',
    semiannually: 'Semiannually',
    annually: 'Annually',
    delivery_note: 'Delivery Note',
    consumption_rate: 'Discount Per',
    consumption_fees: 'Consumption fees',
    consumption_value: 'Consumption fees',
    add_check: 'Add Check',
    checkup_type: 'Checkup Type',
    checkup_number: 'Checkup Number',
    insurance_company: 'Insurance Company',
    delivered_by: 'Delivered By',
    car_received_status: 'Car Received Status',
    maintenance_required: 'Maintenance Required',
    direction: 'Direction',
    description_required: 'Description is required and cannot be empty',
    insurance_company_required: 'Insurance company must be added',
    customer_required: 'Customer must be added',
    car_model_required: 'Car model must be added',
    car_brand_required: 'Car manufacturer must be added',
    car_color_required: 'Car color is required',
    please_add_one_car_received_status: 'At least one car received status must be added',
    please_add_one_car_maintenance: 'At least one maintenance request must be added',
    checkup_id: 'Car Receipt Identifier',
    owner_mobile_number: 'Owner Mobile',
    discountType: 'Discount Type',
    report_day: 'Select Day',
    exit_time: 'Shift End Time',
    chose_user: 'Select User',
    report_type: 'Report Type',
    printer_type: 'Printer Type',
    quotation: 'Quotation',
    car_location: 'Car Location',
    transportant_info: 'Transporter Information',
    transportant_name: 'Transporter Name',
    transport_direction: 'Departure Direction',
    driver_name: 'Driver Name',
    driver_mobile: 'Driver Mobile',
    trnasport_type: 'Transport Type',
    store: 'Warehouse Number',
    special_return: 'Special Return',
    return_total_price: 'Total Returned Amount',
    print_return: 'Print Return',
    viewr_pdf: 'Download PDF',
    add_note: 'Add Note',
    photo_gallery: 'Photo Gallery',
    warnings: 'Warnings',
    add_warning: 'Add Warning',
    select_template: 'Select Template',
    template_vars_required: 'All template variables must be filled',
    template_required: 'Template selection is required',
    whatsapp_mobile_required: 'Mobile number must be registered as WhatsApp and cannot be empty',
    view_request: 'View Request',
    sent_date: 'Sent Date',
    returned_by_receipt: 'Return by Receipt',
    sent_qty: 'Sent Quantity',
    sent_total: 'Sent Total',
    received_qty: 'Received Quantity',
    received_total: 'Received Total',
    returned_qty: 'Returned Quantity',
    returned_total: 'Returned Total',
    support_terms_title: 'Payment Terms',
    support_terms_label: 'Technical Support Terms and Conditions',
    field_required: 'This field is required',
    activity: 'Activity',
    points: 'Points',
    system_type: 'System Type',
    provide_devices: 'Provide Devices',
    total_price: 'Total Price',
    file_type: 'File Type',
    attachment: 'Attachment',
    edit: 'Edit',
    comments: 'Comments',
    operating_costs: 'Operating Costs',
    operating_expenses: 'Operating Expenses',
    sold_items: 'Sold Items',
    advertising_campaign: 'Advertising Campaign',
    advertising_campaigns: 'Advertising Campaigns',
    request_approval: 'Request Approval',
    ad_location: 'Advertisement Location',
    expected_cost: 'Expected Cost',
    approvals: 'Approvals',
    request_date: 'Request Date',
    sender: 'Sender',
    approved_date: 'Approval Date',
    approved_by: 'Approved By',
    specifications: 'Specifications',
    cost: 'Cost',
    ad_materials: 'Advertisement Materials',
    view_project: 'View Project',
    issue_version: 'Issue Version',
    company_or_entity: 'Company/Entity',
    trade_name: 'Trade Name',
    order_info: 'Order Information',
    agent_commission: 'Agent Commission',
    product_name: 'Product Name',
    quotation_number: 'Quotation Number',
    include: 'Include',
    payment_terms: 'Payment Terms',
    delivery_terms: 'Delivery Terms',
    support_terms: 'Support Terms',
    requirements_terms: 'Customer Requirements',
    scope_of_work: 'Scope of Work',
    signature_type: 'Signature Type',
    sign_in: 'Sign In',
    sign_out: 'Sign Out',
    out_of_scope: 'Out of Scope',
    payment_methods: 'Payment Methods',
    responsible: 'Responsible',
    deadline: 'Deadline',
    close_date: 'Close Date',
    support_request_description: 'Support Request Description',
    add_job_order: 'Add Job Order',
    job_order_number: 'Job Order Number',
    car_entry_date: 'Car Entry Date',
    program_features: 'Program Features',
    resend: 'Resend',
    stop_campaign: 'Stop Campaign',
    campaign_data: 'Campaign Data',
    whatsapp_campaign: 'WhatsApp Campaign',
    statistics: 'Statistics',
    customers_count: 'Number of Customers',
    read_count: 'Read Count',
    response_count: 'Response Count',
    buyers_count: 'Number of Buyers',
    top_city_purchase: 'Top Purchasing Cities',
    top_city_followup: 'Top Follow-up Cities',
    riyadh: 'Riyadh',
    dammam: 'Dammam',
    responded_customers: 'Customers Who Responded',
    response_date: 'Response Date',
    last_message: 'Last Message',
    send_reply: 'Send Reply',
    purchased_customers: 'Customers Who Purchased',
    send_invoice: 'Send Invoice',
    returned_items: 'Returned Items',
    price_with_vat: 'Price Including VAT',
    returned_price_with_vat: 'Returned Price Including VAT',
    add_sms_message: 'Add SMS Message',
    message_customers: 'Message Customers',
    select_customer: 'Select Customer',
    car_customers: 'Car Customers',
    billing_customers: 'Billing Customers',
    normal_message: 'Normal Message',
    stop_customer_version: 'Stop Customer Version',
    reactivate_customer: 'Reactivate Customer After Stop',
    empty_message_error: 'Cannot send empty message',
    sms_send_success: 'Message sent successfully - will appear to customers within the next 5 minutes',
    sms_send_error: 'Error sending message',
    success: 'Success',
    error: 'Error',
    item_not_available: 'Item not available or is a service item',
    quantity_not_zero: 'Quantity must be non-zero',
    add_item_without_name: 'Cannot add item without name',
    support_description_required: 'Support description must be provided',
    support_ticket_updated_successfully: 'Support ticket updated successfully',
    old_messages: 'Old Messages',
    or_upload_file: 'Or you can upload a file',
    message_text_required: 'Message text is always required',
    message_title_required: 'Message title is always required',
    number_list_required: 'At least one number must be added to the numbers list',
    image_title_required: 'Image title must be provided',
    document_title_required: 'Document title must be provided',
    video_title_required: 'Video title must be provided',
    message_queued_notice: 'Message added to queue - sending duration depends on number of recipients',
    item_code_required: 'Item code is always required',
    item_price_required: 'Item price must be added before adding',
    item_already_exists: 'Item already exists - please verify',
    item_not_found_add_card: 'Item not found - please add item card first',
    item_code_required_for_non_existing: 'Cannot add non-existing item - Item code is always required',
    return_qty_exceeds_allowed: 'Cannot return items more than available quantity: ',
    qty_must_be_nonzero: 'Quantity must be non-zero',
    item_name_required: 'Cannot add item without name',
    item_price_nonzero: 'Item price must be non-zero',
    invoice_number_required: 'Invoice number is always required',
    vendor_data_required: 'Vendor data must be filled before adding invoice',
    no_matching_invoice: 'No matching invoice - please verify and try again or invoice may have been returned',
    internal_invoice: 'Internal Invoice',
    non_buying_customers: 'Non-Buying Customers',
    buying_customers: 'Buying Customers',
    expired_customers: 'Expired Customers',
    no_row_selected: 'No row selected',
    selected_deleted: 'Selected items deleted',
    selected_returned: 'Selected items returned',
    invoice_returned: 'Invoice returned',
    invoice_deleted_success: 'Invoice deleted successfully',
    return_items_selection_required: 'Please select items you want to return - select at least one item',
    invoice_issued: 'Invoice issued',
    unknown_customer: 'Unknown Customer',
    note_required: 'Note must be provided',
    procedure_updated_successfully: 'Procedure updated successfully',
    country_code: 'Country Code (2 letters in English)',
    ar_company_name: 'Company/Entity in Arabic',
    street_name_ar: 'Street (Arabic)',
    street_name_en: 'Street (English)',
    district_ar: 'District (Arabic)',
    district_en: 'District (English)',
    city_en: 'City (English)',
    city_ar: 'City (Arabic)',
    zatca_integrated_worning: 'You are now integrating with ZATCA - Are you sure you want to continue?',
    you_will_save_information_without_any_creating_action: 'Information will be saved without any action - until you change status to enabled',
    all_fields_required: 'All fields are required',
    vat_number_required: 'VAT number is always required and must be 10 or 15 digits',
    crt_number_requirs: 'CR number is required and must be 10 digits',
    vat_number_start_with_3: 'VAT number must start with digit 3 only',
    vat_number_end_with_3: 'VAT number must end with digit 3 only',
    branch_number_requirs: 'Branch number must be 4 digits',
    building_no_requirs: 'Building number must be 4 digits',
    ziocide_requirs: 'Zipcode must be 5 digits',
    you_will_create_private_and_public_keys_only: 'A certificate will be created only - Are you sure you want to continue?',
    you_will_create_simultation_certificat: 'You will integrate with ZATCA in the test environment - Are you sure you want to continue?',
    you_will_create_production_certificat: 'You will integrate with ZATCA for production - Are you sure you want to continue?',
    continue: 'Continue',
    address_ar_requirs: 'Arabic address must not exceed 100 characters',
    address_en_requirs: 'English address must not exceed 100 characters and contain English letters and numbers only',
    otp_number: 'OTP Number',
    opt_number_description: '- OTP Number: One-time password obtained from the Fatoora platform on the ZATCA website',
    compnay_name_en_requirs: 'Company name in English must contain English letters and numbers only',
    updated_successfully: 'Updated successfully',
    updated_successfully_zatca: 'Updated successfully - Certificate will be created or integration will complete within the next few hours',
    otp_number_required: 'One-time password is required and must consist of 6 digits',
    contact_person: 'Contact Person Name',
    contact_person_mobile: 'Contact Person Mobile',
    who_will_contact: 'Primary Contact',
    main_number: 'Primary Number',
    jvtype: 'Voucher Type',
    jv_purchase: 'Purchase Invoice',
    jv_vendors: 'Vendor Payment',
    return_payment_from_vendor: 'Return Payment',
    general_payment: 'General Payment Method',
    balanced_payments: 'Balance Required',
    classid_balanced: 'Balance Account',
    class_name_balanced: 'Balance Account Name',
    post_balance: 'Post Balance',
    add_return: 'Add Return',
    return_qty: 'Returned Quantity',
    allowed_qty: 'Allowed Return Quantity',
    vendor_category: 'Vendor Classification',
    only_vendor: 'Vendor Only',
    vendor_and_customer: 'Customer & Vendor',
    main_print_settings: 'Main Sections',
    invoice_print_settings: 'Invoice Printing',
    quotation_print_settings: 'Quotation Printing',
    job_card_print_settings: 'Job Order Printing',
    add_new_row: 'Add New Rows',
    delete_old: 'Delete Previous and Start Fresh',
    purchase_accounts: 'Purchase Account',
    messages: 'Messages',
    sparepart_required: 'Required Spare Parts',
    edit_qty: 'Edit Quantity',
    edit_price: 'Edit Price',
    zatca_create_cert_only: 'Create Certificate Only',
    zatca_sandbox_integration: 'Test Integration',
    zatca_production_integration: 'Production Integration',
    zatca_not_active: 'Not Enabled',
    zatca_enable_integration: 'Enable Integration',
    add_work_type: 'Add Work Type',
    work_orders_count: 'Number of Work Orders',
    cars_count: 'Number of Cars',
    operation_number: 'Operation Number',
    car: 'Car',
    operation_date: 'Operation Date',
    expected_hours: 'Expected Hours',
    operation_hours: 'Operation Hours',
    sold_hours: 'Sold Hours',
    sold_value: 'Sold Value',
    start_date_before_end_date: 'Start date must be less than or equal to end date',
    search_in_table: 'Search in Table',
    whats_campaign: 'WhatsApp Campaign',
    whats_campaign_with_device: 'Program Campaign with Device',
    jeddah: 'Jeddah',
    sent_time: 'Sent Time',
    sent_to: 'Sent To',
    read_messages: 'Read Messages',
    contacted_customers: 'Customers Contacted',
    purchased: 'Purchased',
    top_selling_cities: 'Top Selling Cities',
    top_responsive_cities: 'Top Responsive Cities',
    connected: 'Connected',
    yes: 'Yes',
    saturday: 'Saturday',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    technical_support: 'Technical Support',
    mobile_number: 'Mobile Number',
    company_or_institution: 'Company/Institution',
    commercial_register: 'Commercial Register',
    tax_number: 'Tax Number',
    device_insurance: 'Device Insurance',
    points_count: 'Number of Points',
    by: 'By',
    installation_delivery_terms: 'Installation and Delivery Terms',
    customer_requirements: 'Customer Provided Requirements',
    maintenance_request_description: 'Maintenance Request Description',
    installment: 'Installment',
    note: 'Note',
    whatsapp_message: 'WhatsApp Message',
    maintenance_requests: 'Maintenance Requests',
    view_maintenance_request: 'View Maintenance Request',
    select_items_to_return: 'Please select one or more items from the invoice to return',
    item_type: 'Item Type',
    confirm_delete_vendor: 'Are you sure you want to delete this vendor?',
    vendor_item_saved_successfully: 'Item added/updated successfully',
    status_under_review: 'Under Review',
    status_received: 'Received',
    status_canceled: 'Canceled',
    status_partial_received: 'Partial Receipt',
    status_new_request: 'New Request',
    status_paid: 'Paid',
    status_in_progress: 'In Progress',
    salary_deduction: 'Salary Deduction',
    add_advance: 'Add Advance',
    add_bonus: 'Add Bonus',
    issue_salary: 'Issue Salary',
    work_start_date: 'Work Start Date',
    end_of_service_bonus: 'End of Service Bonus',
    salary_source: 'Posted Salary',
    total_salary: 'Total Salary',
    discounts: 'Discounts',
    advances: 'Advances',
    bonuses: 'Bonuses',
    maintenance_cards_percentage: 'Maintenance Cards Percentage',
    sales_percentage: 'Sales Percentage',
    net_salary: 'Net Salary',
    housing_allowance: 'Housing Allowance',
    transport_allowance: 'Transport Allowance',
    food_allowance: 'Food Allowance',
    other_allowances: 'Other Allowances',
    card_date: 'Card Date',
    car_type: 'Car Type',
    total_services: 'Total Services',
    work_percentage: 'Work Percentage',
    invoice_sales: 'Invoice Sales',
    advance_date: 'Advance Date',
    advance_amount: 'Advance Amount',
    installment_count: 'Number of Installments',
    remaining_amount: 'Remaining Amount',
    bonus_date: 'Bonus Date',
    bonus_amount: 'Bonus Amount',
    bonus_reason: 'Bonus Reason',
    discount_date: 'Discount Date',
    discount_amount: 'Discount Amount',
    discount_reason: 'Discount Reason',
    custodies: 'Custodies',
    custody_date: 'Custody Date',
    currency: 'SAR',
    general_center: 'General Center',
    german_section: 'German Section',
    branch: 'Branch',
    income_center: 'Income Center',
    cashier_employee: 'Cashier Employee',
    general_management: 'General Management',
    suppliers: 'Suppliers',
    permissions_group: 'Permissions Group',
    permissions_group_note: 'If you do not select a group, current permissions will remain unchanged',
    settings_saved_tax_note: 'Settings saved. Please note that if you change the VAT number, you must reactivate the version',
    sms_message: 'SMS Message',
    search_by_customer_or_tax: 'Search by customer name, CR number, or VAT number',
    send_message: 'Send Message',
    clients_list: 'Clients List',
    client: 'Client',
    register_number: 'Register Number',
    domain: 'Domain',
    last_invoice: 'Last Invoice',
    receive_messages: 'Receive Messages',
    expiration_date: 'Expiration Date',
    support_status: 'Support Status',
    activity_status: 'Activity Status',
    edit_customer: 'Edit Customer',
    add_message: 'Add Message',
    message_templates: 'Message Templates',
    updated_by: 'Updated By',
    actions: 'Actions',
    sms_messages: 'SMS Messages',
    whatsapp_messages: 'WhatsApp Messages',
    customer_source: 'Customer Source',
    manufacturer: 'Manufacturer',
    manufacture_year: 'Manufacturing Year',
    please_wait: 'Please wait ... Please Wait',
    package_invoice_canceled_at: 'Package invoice canceled on',
    reason: 'Due to',
    card_canceled_at: 'This card was canceled on',
    cancel_reason: 'And cancellation reason',
    labor: 'Labor',
    warning: 'Warning',
    confirm: 'Confirm',
    confirm_cancel_invoice_warning: 'Are you sure you want to cancel this invoice? This action cannot be reversed',
    confirm_cancel_invoice: 'Are you sure you want to cancel this invoice?',
    invoices_list: 'Invoices List',
    invoice_return_reason_required: 'Invoice return reason must be provided and must be more than 10 characters',
    select_cancel_reason: 'Please select a cancellation reason',
    cancel_reason_input_error: 'Input Error',
    cancel_reason_service_issue: 'Poor Service',
    cancel_reason_price: 'Inappropriate Price',
    invoice_canceled_successfully: 'Invoice returned successfully',
    confirm_delete_continue: 'Are you sure you want to continue with deletion?',
    status_delete_warning: 'If the status is deleted - and is used in one of the system sections - you must update the used statuses before continuing',
    accept_responsibility: 'I accept my responsibility',
    image: 'Image',
    file: 'File',
    video: 'Video',
    upload_file_optional: 'Or you can upload a file',
    all_cities: 'All Cities',
    all_industries: 'All Industries',
    manual_send: 'Manual Send',
    card_copy: 'Card Copy',
    invoice_copy: 'Invoice Copy',
    verification_code: 'Verification Code',
    text_message: 'Text Message',
    text_message_with_image: 'Text Message with Image',
    text_message_with_document: 'Text Message with Document',
    text_message_with_video: 'Text Message with Video',
    all_customers: 'All Customers',
    shipment_date: 'Shipment Date',
    sent_products: 'Sent Products',
    total_sent: 'Total Sent',
    received_products: 'Received Products',
    total_received: 'Total Received',
    returned_by: 'Returned By',
    add_shipment: 'Add Shipment',
    product_update_save_note: 'Updated successfully - don\'t forget to press Save button to apply the changes',
    mobile_format_invalid: 'Customer phone number must be 10 digits starting with 05',
    price_empty_warning: 'Cannot add empty price - please add price or zero if no value',
    locking_invoice_warning: 'Please note: Once the invoice is issued, no modifications can be made - please verify all invoice data before issuing',
    item_type_label: 'Item Type',
    unit_label: 'Unit',
    delete_button: 'Delete',
    insurance_label: 'Insurance',
    total_after_insurance: 'Total After Insurance',
    unit_item_name: 'Item',
    pay_more_than_invoiced: 'Cannot pay amount exceeding total invoice amount',
    item_price_empty_warning: 'Cannot add empty price - please add the price in price field or add zero if without value',
    review_invoice: 'Review Invoice',
    cancel_invoice: 'Cancel Invoice',
    issue_invoice: 'Issue Invoice',
    nd_start_date: 'Start Date',
    nd_end_date: 'End Date',
    nd_branches: 'Branches',
    nd_search: 'Search',
    nd_finance_module: 'Finance Module',
    nd_calendar_dashboard: 'Calendar Dashboard',
    nd_calendar_type: 'Calendar Type',
    nd_worker_tasks: 'Worker Tasks',
    nd_delivery_cars: 'Delivery Cars',
    nd_no_records: 'No records found for the selected range.',
    nd_job_cards: 'Job Cards',
    nd_work_orders: 'Work Orders',
    nd_job_orders: 'Job Orders',
    nd_income_by: 'Income by',
    nd_intervals: 'intervals',
    nd_expense_breakdown: 'Expense Breakdown',
    nd_total_expenses: 'Total Expenses',
    nd_sales_items: 'Sales Items',
    nd_extra_profit: 'Extra Profit',
    nd_total_profit: 'Total Profit',
    nd_total_income: 'Total Income',
    nd_total_salaries: 'Total Salaries',
    nd_total_purchase: 'Total Purchase',
    nd_revenue_or_loss: 'Revenue / Loss',
    nd_payment_types: 'Payment Types',
    nd_balance: 'Balance',
    nd_employee_financial_cards: 'Employee Financial Cards',
    nd_employees: 'employees',
    nd_salary: 'Salary',
    nd_pay_advanced: 'Pay Advanced',
    nd_deductions: 'Deductions',
    nd_net_paid_salary: 'Net Paid Salary',
    nd_branch_summary_income_expense: 'Branch Summary (Income vs. Expense)',
    nd_income: 'Income',
    nd_expense: 'Expense',
    nd_profit: 'Profit',
    nd_loss: 'Loss',
    nd_branch: 'Branch',
    nd_total: 'Total',
    nd_month: 'Month',
    nd_week: 'Week',
    nd_day: 'Day',
    nd_no_date: 'No Date',
    nd_expired: 'Expired',
    nd_expiring: 'Expiring',
    nd_valid: 'Valid',
    nd_employee_labor_performance: 'Employee Labor Performance',
    nd_working: 'Working',
    nd_late: 'Late',
    nd_total_bill: 'Total Bill',
    nd_paid: 'Paid',
    nd_remaining: 'Remaining',
    nd_vat: 'VAT',
    nd_view_details: 'View Details',
    nd_job_card_details: 'Job Card Details',
    nd_plate: 'Plate',
    nd_vehicle: 'Vehicle',
    nd_customer: 'Customer',
    nd_mobile: 'Mobile',
    nd_card_id: 'Card ID',
    nd_received_date: 'Received',
    nd_expected_date: 'Expected',
    nd_status: 'Status',
    nd_under_process: 'Under Process',
    nd_ready_to_collect: 'Ready to Collect',
    nd_closed: 'Closed',
    nd_need_spare_part: 'Need Spare Part',
    nd_checking: 'Checking',
    nd_canceled: 'Canceled',
    nd_early_dismissals: 'Early Dismissals',
    nd_unknown: 'Unknown',
    nd_unknown_branch: 'Unknown Branch',
    nd_work_orders_employee_kpi: 'Work Orders / Employee KPI',
    nd_attendance_collections: 'Attendance Collections',
    nd_periods: 'periods',
    nd_metric: 'Metric',
    nd_working_hours: 'Working Hours',
    nd_lates: 'Lates',
    nd_non_attendance: 'Non-Attendance',
    nd_overtime: 'Overtime',
    nd_rewards: 'Rewards',
    nd_rewards_hint: 'Other rewards and adjustments (overtime and non-attendance shown separately)',
    nd_performance_rating: 'Performance Rating',
    nd_total_job_orders: 'Total Job Orders',
    nd_on_progress: 'On Progress',
    nd_finished: 'Finished',
    nd_recent_task_snapshot: 'Recent Task Snapshot',
    nd_admin_notes: 'Admin Notes',
    nd_add_admin_note: 'Add admin note...',
    nd_update_note: 'Update Note',
    nd_employee_tasks: 'Employee Tasks',
    nd_task_id: 'Task ID',
    nd_task: 'Task',
    nd_due_date: 'Due Date',
    nd_all: 'All',
    nd_active: 'Active',
    nd_on_break: 'On Break',
    nd_on_leave: 'On Leave',
    nd_employee: 'Employee',
    nd_tasks: 'Tasks',
    nd_no_tasks_found: 'No tasks found',
    nd_monthly: 'Monthly',
    nd_weekly: 'Weekly',
    nd_daily: 'Daily',
    att_hr: 'HR',
    att_attendance: 'Attendance',
    att_attendance_exception_mgmt: 'Attendance & Exception Management',
    att_daily_attendance_tracking: 'Daily Attendance Tracking',
    att_date: 'Date',
    att_employees: 'Employees',
    att_on_time: 'On Time',
    att_late: 'Late',
    att_absent: 'Absent',
    att_vacation: 'Vacation',
    att_exceptions: 'Exceptions',
    att_branch: 'Branch',
    att_shift_start: 'Shift Start',
    att_actual_arrival: 'Actual Arrival',
    att_shift_end: 'Shift End',
    att_actual_departure: 'Actual Departure',
    att_not_attended: 'Not Attended',
    att_absence_type: 'Absence Type',
    att_justification_type: 'Justification Type',
    att_reason: 'Reason',
    att_save_attendance: 'Save Attendance',
    att_required_field: 'Required field',
    att_absence_type_required: 'Absence type is required',
    att_justification_type_required: 'Justification type is required',
    att_reason_required: 'Reason is required',
    att_on_vacation: 'On Vacation',
    att_permission: 'Permission',
    att_present_on_time: 'Present & On Time',
    att_late_justified: 'Late (Justified)',
    att_late_early_unjustified: 'Late / Early (Unjustified)',
    att_submit_success: 'Attendance submitted successfully',
    att_backend_pending: 'Backend endpoint not ready yet, payload logged',
    att_justified_delay: 'Justified Delay',
    att_justified_departure: 'Justified Departure',
    att_unjustified: 'Unjustified',
    att_permission_approved_leave: 'Permission (Approved Leave)',
    att_not_justified_absent: 'Not Justified (Absent)',
    att_load_employees_failed: 'Could not load employees',
    att_unknown_branch: 'Unknown Branch',
    att_unknown_employee: 'Unknown Employee',
    ti_quick_search: 'Quick Search',
    ti_from_date: 'From Date',
    ti_to_date: 'To Date',
    ti_new_report: 'New Report',
    ti_report_header: 'Technical Inspection Report',
    ti_office_name: 'Sheikh Al-Mihna for Damage Assessment',
    ti_report_number: 'Report Number',
    ti_date: 'Date',
    ti_date_label: 'Date (Gregorian/Hijri)',
    ti_status: 'Status',
    ti_status_draft: 'Draft',
    ti_status_issued: 'Issued',
    ti_status_final: 'Final',
    ti_vehicle: 'Vehicle',
    ti_vehicle_type: 'Vehicle Type',
    ti_vehicle_model: 'Vehicle Model',
    ti_plate: 'Plate',
    ti_plate_number: 'Plate Number',
    ti_claimant: 'Claimant',
    ti_claimant_name: 'Claimant Name',
    ti_defendant: 'Defendant',
    ti_defendant_name: 'Defendant Name',
    ti_commercial_register: 'Commercial Register',
    ti_cr: 'CR',
    ti_labor_cost: 'Labor Cost',
    ti_labor_cost_sar: 'Labor Cost (SAR)',
    ti_labor_cost_numeric: 'Labor Cost (Numeric)',
    ti_labor_cost_words: 'Labor Cost in Words',
    ti_status_condition: 'Status Condition',
    ti_party_to_replay: 'Other Party Reply',
    ti_actions: 'Actions',
    ti_edit: 'Edit',
    ti_delete: 'Delete',
    ti_preview_print: 'Preview/Print PDF',
    ti_add_report_title: 'Add Technical Inspection Report',
    ti_edit_report_title: 'Edit Technical Inspection Report',
    ti_step_vehicle: 'Vehicle Information',
    ti_step_parties: 'Claim Parties',
    ti_step_findings: 'Technical Findings',
    ti_step_cost_status: 'Cost & Status',
    ti_findings_title: 'Inspections and Technical Findings',
    ti_add_item: 'Add Item',
    ti_item: 'Item',
    ti_save_report: 'Save Report',
    ti_confirm_delete_title: 'Confirm Delete',
    ti_confirm_delete_text: 'Are you sure you want to delete report no.',
    ti_yes_delete: 'Yes, Delete',
    ti_section_vehicle: 'First: Vehicle Data',
    ti_section_parties: 'Second: Claim Parties',
    ti_section_findings: 'Third: Technical Findings',
    ti_section_financial: 'Fourth: Financial Estimate',
    ti_type: 'Type',
    ti_model: 'Model',
    ti_signature_expert: 'Technical Inspection Expert',
    ti_signature_approval: 'Sheikh Approval',
    ti_name_signature: 'Name & Signature',
    ti_load_failed: 'Could not load technical inspection reports',
    ti_success_title: 'Success',
    ti_add_success: 'Report added successfully',
    ti_update_success: 'Report updated successfully',
    ti_save_failed: 'Could not save report',
    ti_delete_success: 'Report deleted successfully',
    ti_delete_failed: 'Could not delete report',
    currency_code: 'Riyal',
    manage_workers: 'Manage Workers',
    nd_full_page: 'Full Page',
    nd_back: 'Back'
  }


  export default enLang;
